import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiForgotSelectcredentialMutationRequest,
  PostApiForgotSelectcredentialMutationResponse,
  PostApiForgotSelectcredential401,
  PostApiForgotSelectcredential403,
} from "../../../types/PostApiForgotSelectcredential";

export function getPostApiForgotSelectcredentialUrl() {
  return `/api/Forgot/SelectCredential` as const;
}

/**
 * {@link /api/Forgot/SelectCredential}
 */
export async function postApiForgotSelectcredential(
  data?: PostApiForgotSelectcredentialMutationRequest,
  config: Partial<
    RequestConfig<PostApiForgotSelectcredentialMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiForgotSelectcredentialMutationResponse,
    ResponseErrorConfig<
      PostApiForgotSelectcredential401 | PostApiForgotSelectcredential403
    >,
    PostApiForgotSelectcredentialMutationRequest
  >({
    method: "POST",
    url: getPostApiForgotSelectcredentialUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
